var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3933_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.2267V10.5C10.0002 7.28 12.6135 4.66667 15.8335 4.66667C19.0535 4.66667 21.6668 7.28 21.6668 10.5V19.2267C24.4902 17.3367 26.3335 14.14 26.3335 10.5C26.3335 4.69 21.6435 0 15.8335 0C10.0235 0 5.33349 4.69 5.33349 10.5C5.33349 14.14 7.17683 17.3367 10.0002 19.2267ZM32.9602 30.03L22.3668 24.7567C21.9702 24.5933 21.5502 24.5 21.1068 24.5H19.3335V10.5C19.3335 8.56333 17.7702 7 15.8335 7C13.8968 7 12.3335 8.56333 12.3335 10.5V35.56C3.93349 33.7867 4.07349 33.81 3.77016 33.81C3.04683 33.81 2.39349 34.1133 1.92683 34.58L0.0834961 36.4467L11.6102 47.9733C12.2402 48.6033 13.1268 49 14.0835 49H29.9268C31.6768 49 33.0302 47.7167 33.2868 46.0133L35.0368 33.7167C35.0602 33.5533 35.0835 33.39 35.0835 33.25C35.0835 31.8033 34.1968 30.5433 32.9602 30.03Z",
    fill: "#9855EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3933_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickPurpleIcon);
export default __webpack_public_path__ + "static/media/click_purple_icon.ac339a5e.svg";
export { ForwardRef as ReactComponent };